export default __webpack_public_path__ + "static/media/tiger-redirect.453c3794.webp";